import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { PlanScheduled } from "../../domain/models/scheduler/plan-scheduled";
import { PlanScheduledRepository } from "../../repositories/scheduler.repository";
import { PlanScheduledRequest } from "../../domain/requests/plans/get-scheduled-plans-request";
import { UpdateSchedulerInstanceRequest } from "../../domain/requests/Scheduler/update-scheduler-instance-request";

@Injectable({ providedIn: 'root' })
export class UpdateSchedulerInstanceUseCase implements UseCase<UpdateSchedulerInstanceRequest, boolean> {

  constructor(private readonly planScheduledRepository: PlanScheduledRepository) {
  }

  execute(request:UpdateSchedulerInstanceRequest): Observable<boolean> {
    return this.planScheduledRepository.updateSchedulerInstance(request);
  }

}